import React, { useContext, useEffect } from "react";
import Search from "../users/Search";
import Users from "../users/Users";
import GithubContext from "../../context/github/githubContext";

const Home = () => {
  const { users, loading, clicked } = useContext(GithubContext);
  const hasResults = users.length > 0 || loading || clicked;

  useEffect(() => {
    document.title = "GitHub Finder — Search & Explore GitHub User Profiles";
  }, []);

  return (
    <div className={`home ${hasResults ? "home--active" : ""}`}>
      <div className="home-search-wrapper">
        <div className="home-hero">
          <h2>
            Find <span className="accent">GitHub</span> Users
          </h2>
        </div>
        <Search />
      </div>
      {hasResults && (
        <div className="home-results">
          <Users />
        </div>
      )}
    </div>
  );
};

export default Home;
